import React from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

const ReturnPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Return and Exchange Policy | Elly Decor</title>
        <meta name="title" content="Return and Exchange Policy | Elly Decor" />
        <meta
          name="description"
          content="Read Elly Decor's Return and Exchange Policy to learn about eligibility, process, fees, and conditions for returning or exchanging your purchases."
        />
      </Helmet>

      <div className="auto-container py-5 text-justify">
        <h2>Return and Exchange Policy for Elly Decor</h2>
        <p><strong>Effective Date:</strong> [Date of Policy Implementation]</p>
        <p>
          At <b>Elly Decor</b>, we strive to ensure your complete satisfaction with your purchase. We understand that sometimes you may need to return or exchange a product. This Return and Exchange Policy outlines the terms and conditions for returns and exchanges at Elly Decor.
        </p>

        <h4>1. Eligibility for Returns and Exchanges</h4>
        <ul>
          <li><b>Timeframe:</b> You may return or exchange eligible products within [Number] days of the original purchase date.</li>
          <li><b>Condition of Products:</b> To be eligible, the product must be in its original condition, unused, unaltered, and with all original tags and packaging intact.</li>
          <li><b>Proof of Purchase:</b> A valid proof of purchase, such as the original invoice or order confirmation, is required.</li>
          <li><b>Exclusions:</b> Generally not eligible for return or exchange:
            <ul>
              <li>Custom-made or personalized items</li>
              <li>Cut fabrics or wallpapers</li>
              <li>Items sold as "final sale" or "clearance"</li>
              <li>Used, damaged, or altered items after delivery</li>
              <li>Products not in their original condition or packaging</li>
              <li>Products where the tags are removed</li>
            </ul>
          </li>
        </ul>

        <h4>2. Reasons for Returns and Exchanges</h4>
        <ul>
          <li><b>Damaged or Defective Products:</b> Contact us within 7 days of delivery with photographic evidence. We will arrange a replacement or refund.</li>
          <li><b>Incorrect Product:</b> Contact us within 7 days if the product received differs from your order. We will send the correct product or offer a refund.</li>
          <li><b>Change of Mind:</b> You may return eligible items if you change your mind, subject to conditions. Return shipping costs and a restocking fee may apply.</li>
        </ul>

        <h4>3. Return and Exchange Process</h4>
        <ul>
          <li><b>Contact Us:</b> Email <a href="mailto:info@ellydecor.in">info@ellydecor.in</a> or call <a href="tel:+91 98214 95696">+91 98214 95696</a> with your order details and reason.</li>
          <li><b>Product Inspection:</b> We will provide a Return Authorization (RA) number and return instructions. Ensure products are securely packaged.</li>
          <li><b>Return Shipping:</b>
            <ul>
              <li>We cover return shipping for damaged, defective, or incorrect products.</li>
              <li>You cover return shipping for change of mind cases.</li>
            </ul>
          </li>
          <li><b>Refund or Exchange:</b>
            <ul>
              <li>Exchanges processed once eligibility is confirmed; if unavailable, a refund or store credit will be provided.</li>
              <li>Refunds are issued to the original payment method within 7 business days after inspection.</li>
            </ul>
          </li>
        </ul>

        <h4>4. Fees and Charges</h4>
        <ul>
          <li>Return shipping for change of mind is covered by the customer.</li>
          <li>A restocking fee of [Percentage]% may apply for change of mind returns.</li>
          <li>Original shipping costs are non-refundable unless due to our error.</li>
        </ul>

        <h4>5. In-Store Returns and Exchanges</h4>
        <p>Products purchased online may also be returned or exchanged at our physical store at [Your Store Address], subject to the same conditions. Bring proof of purchase.</p>

        <h4>6. Custom Orders</h4>
        <p>Custom-made or personalized items are not eligible for return or exchange unless damaged or defective upon arrival.</p>

        <h4>7. Amendments to This Policy</h4>
        <p>We may update this policy periodically. Updates will be posted on this page with the effective date.</p>

        <h4>8. Contact Us</h4>
        <p>
          <b>Elly Decor</b><br />
          Shop No. 2, Block A, CLR Complex, Sector 149, Noida, Uttar Pradesh 201310<br />
          Email: <a href="mailto:info@ellydecor.in">info@ellydecor.in</a><br />
          Phone: <a href="tel:+91 98214 95696">+91 98214 95696</a>
        </p>
      </div>
    </>
  );
};

export default ReturnPolicy;
